export function unreachable(n: never): never {
  return n;
}
